import { render, staticRenderFns } from "./bookingSpaceLogDialog.vue?vue&type=template&id=9faf690c&"
import script from "./bookingSpaceLogDialog.vue?vue&type=script&lang=js&"
export * from "./bookingSpaceLogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9faf690c')) {
      api.createRecord('9faf690c', component.options)
    } else {
      api.reload('9faf690c', component.options)
    }
    module.hot.accept("./bookingSpaceLogDialog.vue?vue&type=template&id=9faf690c&", function () {
      api.rerender('9faf690c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/bookingSpaceLogDialog.vue"
export default component.exports